import {
  IEditVasTypePayload,
  IGetVasTypeList,
  IVasTypeCreate,
  IVasTypeDetails,
  IVasTypeListSearch,
} from "../../../types/master/vasTypeInterface";
import { VasTypeActionTypes, VasTypeActions } from "../../actionTypes/master/vasTypeActionTypes";

export const createVasType = (payload: IVasTypeCreate): VasTypeActionTypes => ({
  type: VasTypeActions.CREATE_VAS_TYPE,
  payload,
});

export const getVasTypeList = (payload: IVasTypeListSearch): VasTypeActionTypes => ({
  type: VasTypeActions.GET_VAS_TYPE_LIST,
  payload,
});

export const setVasTypeList = (vasTypeList: Array<IGetVasTypeList>): VasTypeActionTypes => ({
  type: VasTypeActions.SET_VAS_TYPE_LIST,
  payload: vasTypeList,
});

export const setVasTypeListPageCount = (payload: number): VasTypeActionTypes => ({
  type: VasTypeActions.SET_VAS_TYPE_LIST_PAGE_COUNT,
  payload,
});

export const getVasTypeDataById = (id: number | string): VasTypeActionTypes => ({
  type: VasTypeActions.GET_VAS_TYPE_DATA_BY_ID,
  payload: id,
});

export const setVasTypeDataById = (payload: IVasTypeDetails): VasTypeActionTypes => ({
  type: VasTypeActions.SET_VAS_TYPE_DATA_BY_ID,
  payload,
});

export const editVasType = (payload: IEditVasTypePayload): VasTypeActionTypes => ({
  type: VasTypeActions.EDIT_VAS_TYPE_DATA_BY_ID,
  payload,
});
